import { fetchHTML } from '@utils';
import { pubsub } from '@services';
import { notyf } from '@modules';

class MainSearch extends HTMLElement {
  connectedCallback() {
    this.unsubscribeSortChange = pubsub.subscribe('sort:changed', () => this.handleSortChange());
    this.unsubscribeFiltersUpdated = pubsub.subscribe('filters:updated', () =>
      this.handleSortChange()
    );
  }

  disconnectedCallback() {
    this.unsubscribeSortChange();
    this.unsubscribeFiltersUpdated();
  }

  /**
   * Handle sort change.
   */
  async handleSortChange() {
    const searchParams = new URLSearchParams(window.location.search);

    try {
      const html = await fetchHTML(
        `${window.location.pathname}?section_id=main-search&${searchParams}`
      );

      this.renderProductGrid(html);
    } catch (error) {
      console.error(error);
      notyf.error('Failed to update sort order');
    }
  }

  /**
   * Render the product grid.
   * @param {HTMLElement} html - The HTML to render.
   */
  renderProductGrid(html) {
    const parsedMainSearch = html.querySelector('main-search');

    this.innerHTML = parsedMainSearch.innerHTML;
  }
}

customElements.define('main-search', MainSearch);
